module.exports = __webpack_public_path__ + "img/patient_black.042cfb3b.svg";